'use client'

import { useEffect } from 'react'

import { api } from '@/shared/services/api'

const STORAGE_KEY = 'pgee_daily_login_ping'

function todayKey() {
  return new Date().toISOString().slice(0, 10)
}

export function useDailyLoginPing() {
  useEffect(() => {
    async function ping() {
      const today = todayKey()
      if (localStorage.getItem(STORAGE_KEY) === today) return
      try {
        await api.post('/user/sessions/daily_check')
        localStorage.setItem(STORAGE_KEY, today)
      } catch {}
    }

    ping()

    function onVisibilityChange() {
      if (document.visibilityState === 'visible') ping()
    }

    document.addEventListener('visibilitychange', onVisibilityChange)
    return () => document.removeEventListener('visibilitychange', onVisibilityChange)
  }, [])
}
